module.exports = __webpack_public_path__ + "static/media/ot-dest.d0663c70.svg";